import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { CompaniesService } from "../companies/companies.service";
import { ApiService } from "../shared";
import { ProjectsService } from "../projects/projects.service";
import { ConfigService } from "../config.service";
import { AccountsService } from "../accounts/accounts.service";
import { ProjectMember } from "../projectmember/projectmember.service";
import * as Joi from "joi";
import * as async from "async";

@Injectable()
export class UsersService {
  static currentUser: any;
  private serviceUrl = ConfigService.serviceUrl;
  private usersSchema: Joi.Schema = Joi.array().items(
    Joi.object().keys({
      checkPassword: Joi.bool(),
      active: Joi.bool().required(),
      name: Joi.string().min(1).required(),
      // password: Joi.string().allow('').when('checkPassword', {is: true, then: Joi.string().min(1).required()}),
      // confirmPassword: Joi.string().allow('').when('checkPassword', {is: true, then: Joi.valid(Joi.ref('password')).required()}),
      email: Joi.string().email().min(1).required(),
      id: Joi.string(),
      account_id: Joi.string(),
      created_at: Joi.date(),
      updated_at: Joi.date(),
      projects: Joi.array(),
      image: Joi.object()
    })
  );

  constructor(
    private http: Http,
    private companiesService: CompaniesService,
    private apiService: ApiService,
    private projectsService: ProjectsService,
    private memberService: ProjectMember
  ) {}

  getUsers(accountId): Observable<any> {
    return this.http
      .get(`${this.serviceUrl}/accounts/` + accountId + `/users`)
      .map((res) => {
        return this.extractData(res);
      })
      .catch(this.handleError);
  }

  validateUsers(users: any[]): any {
    return Joi.validate(users, this.usersSchema, (err, v) => {
      return err || true;
    });
  }

  createUser(user: any, accountId: string): Observable<any> {
    return new Observable((obs) => {
      accountId = accountId || AccountsService.currentAccount.id;
      user.checkPassword = true;
      let projects = user.projects ? user.projects.slice() : undefined;
      delete user.projects;
      let validUsers = this.validateUsers([user]);
      delete user.confirmPassword;
      delete user.checkPassword;
      if (validUsers !== true) {
        obs.error(validUsers);
        obs.complete();
      }
      this.http
        .post(`${this.serviceUrl}/accounts/` + accountId + `/users`, user)
        .subscribe(
          (resp) => {
            let usr = this.extractData(resp);
            let members = this.getProjectMembers(usr.id, projects);
            if (members.length > 0) {
              this.memberService.createProjectMembers(members).subscribe(
                (m) => {
                  obs.next(usr);
                  obs.complete();
                },
                (err) => {
                  this.handleError(err);
                  obs.error(err);
                  obs.complete();
                }
              );
            } else {
              obs.next(usr);
              obs.complete();
            }
          },
          (error) => {
            return this.handleError(error);
          }
        );
    });
  }

  getProjectMembers(userId: string, projects: any[]): any[] {
    let members = [];
    if (projects) {
      projects.map((project) => {
        members.push({
          project_id: project.id,
          user_id: userId,
          role: project.role
        });
      });
    }
    return members;
  }

  createUsers(users: any[], accountId: string): Observable<any> {
    let newUsers = [];
    return new Observable((obs) => {
      async.eachSeries(
        users,
        (user, callback) => {
          this.createUser(user, accountId).subscribe(
            (u) => {
              newUsers.push(u);
              callback();
            },
            (err) => {
              obs.error(err);
              obs.complete();
            }
          );
        },
        (err) => {
          if (err) {
            obs.error(err);
            obs.complete();
          } else {
            obs.next(newUsers);
            obs.complete();
          }
        }
      );
    });
  }

  editUser(user: any): Observable<any> {
    return new Observable((obs) => {
      if (user.password && user.password !== "") {
        user.checkPassword = true;
      }
      let projects = user.projects ? user.projects.slice() : undefined;
      delete user.projects;
      let validUsers = this.validateUsers([user]);
      delete user.confirmPassword;
      delete user.checkPassword;
      if (validUsers !== true) {
        obs.error(validUsers);
        obs.complete();
      }
      delete user.confirmPassword;
      this.http.put(`${this.serviceUrl}/users/` + user.id, user).subscribe(
        (resp) => {
          let usr = this.extractData(resp);
          if (projects && projects.length > 0) {
            this.editProjectMembers(usr.id, projects).subscribe((m) => {
              obs.next(usr);
              obs.complete();
            });
          } else {
            obs.next(usr);
            obs.complete();
          }
        },
        (error) => {
          return this.handleError(error);
        }
      );
    });
  }

  createMembers(userId: string, projects: any[]): Observable<any> {
    return new Observable((obs) => {
      let members = [];
      if (projects) {
        projects.map((project) => {
          if (project.isNew) {
            members.push({
              project_id: project.id,
              user_id: userId,
              role: project.role
            });
          }
        });
      }
      if (members.length > 0) {
        this.memberService.createProjectMembers(members).subscribe(
          (m) => {
            obs.next();
            obs.complete();
          },
          (err) => {
            this.handleError(err);
            obs.error(err);
            obs.complete();
          }
        );
      } else {
        obs.next();
        obs.complete();
      }
    });
  }

  resendActivationLink(user: any) {
    return new Observable((obs) => {
      this.http
        .post(`${this.serviceUrl}/users/${user.id}/activation`, {})
        .subscribe(
          (resp) => {
            obs.next(resp);
            obs.complete();
          },
          (error) => {
            return this.handleError(error);
          }
        );
    });
  }

  deleteMembers(userId: string, projects: any[]): Observable<any> {
    return new Observable((obs) => {
      let members = [];
      if (projects) {
        projects.map((project) => {
          if (project.isDelete) {
            members.push({
              project_id: project.id,
              user_id: userId,
              role: project.role
            });
          }
        });
      }
      if (members.length > 0) {
        this.memberService.deleteProjectMembers(members).subscribe(
          (m) => {
            obs.next();
            obs.complete();
          },
          (err) => {
            this.handleError(err);
            obs.error(err);
            obs.complete();
          }
        );
      } else {
        obs.next();
        obs.complete();
      }
    });
  }

  editProjectMembers(userId: string, projects: any[]): Observable<any> {
    return new Observable((obs) => {
      this.deleteMembers(userId, projects).subscribe((d) => {
        this.createMembers(userId, projects).subscribe((c) => {
          obs.next();
          obs.complete();
        });
      });
    });
  }

  editUsers(users: any[]): Observable<any> {
    let editedUsers = [];
    return new Observable((obs) => {
      async.eachSeries(
        users,
        (user, callback) => {
          this.editUser(user).subscribe(
            (u) => {
              editedUsers.push(u);
              callback();
            },
            (err) => {
              obs.error(err);
              obs.complete();
            }
          );
        },
        (err) => {
          if (err) {
            obs.error(err);
            obs.complete();
          } else {
            obs.next(editedUsers);
            obs.complete();
          }
        }
      );
    });
  }

  getProjectMemberList(projectIds: string[]) {
    return this.memberService.getProjectMemberList(projectIds);
  }

  getItemsPerPageValues(): number[] {
    return ConfigService.itemsPerPageValues;
  }

  getItemsPerPage(): number {
    return ApiService.getItemsPerPage();
  }

  saveItemsPerPage(value: number) {
    ApiService.saveItemsPerPage(value);
  }

  getProjects() {
    return this.projectsService.getProjectList();
  }

  private extractData(res: Response) {
    let body = res.json();
    return body;
  }

  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || "";
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/users/users.service.ts